import axios from "../../axios/axiosRoot";

export const listarPastas = ({ commit }, payload) => {
    commit("publico/explorer/controller/setListaPastas", null)

    let config = {
        params: {
            diretorio: payload,
            tipo: 'diretorio'
        }
    }

    return axios
    .get("publico/explorer/controller/listar.php", config)
    .then(resp => {
        if (resp.data.status == true) commit("setListaPastas", resp.data.dados)
        else commit("setListaPastas", null)
    })
    .catch(error => {
        commit("setListaPastas", null)
        console.error(error)
    });
};

export const listarArquivos = ({ commit }, payload) => {
    commit("setListaArquivos", null)

    let config = {
        params: {
            diretorio: payload,
            tipo: 'arquivo'
        }
    }

    return axios
    .get("publico/explorer/controller/listar.php", config)
    .then(resp => {
        if (resp.data.status == true) commit("setListaArquivos", resp.data.dados)
        else commit("setListaArquivos", null)
    })
    .catch(error => {
        commit("setListaArquivos", null)
        console.error(error)
    });
};

export const downloadFile = ({ commit }, payload) => {

    return axios({
        method: 'get',
        url: payload,
        responseType: 'blob'
      })
};

export const deleteFile = ({ commit }, payload) => {
    return axios
    .post("publico/explorer/controller/arquivo.php", payload)
    .catch(error => {
        console.error(error)
    });
};


export const upload = ({ commit }, payload) => {
    return axios
    .post("publico/explorer/controller/arquivo.php", payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
    })
    .catch(error => {
        console.error(error)
    });
};